import { LoadError } from '@core/utils/errors'
import { logError } from '@core/utils/logger'
import { QueryCache, QueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { t } from 'i18next'

const onError = (err: unknown) => {
  if (!(err instanceof AxiosError)) return logError(new LoadError(String(err)))
  if (err.response?.status === 401) return

  const { detail, errors } = err.response?.data ?? {}

  const errorMsg = detail ?? t('api.errors.anErrorOccurred')
  const description = Array.isArray(errors) ? errors.join('\n') : ''
  logError(new LoadError(description || errorMsg))
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount) => failureCount <= 1,
    },
    mutations: { onError },
  },
  queryCache: new QueryCache({ onError }),
})
